<div
  class="sb-live-navbar-container"
  [ngClass]="{
    'background-color-regular': light,
    'background-color-dark': !light
  }"
>
  <div class="sb-live-navbar--content">
    <button
      class="sb-live-navbar--back-button codere-icon icon-arrow-left"
      [ngClass]="{
        'background-color-regular': light,
        'background-color-dark': !light,
        'color-muted': light,
        'color-light': !light
      }"
      tappable
      (click)="close?.emit()"
      *ngIf="hasBackButton"
    ></button>
    <p class="sb-live-navbar--breadcrumbs">
      <span
        *ngFor="let breadcrumb of breadcrumbs; let last = last"
        class="sb-live-navbar--link"
        [ngClass]="{
          'color-muted': light,
          'color-light': !light
        }"
      >
        {{ last ? breadcrumb : (breadcrumb + ' / ' | sportsTitleCase) }}
      </span>
    </p>
  </div>
  <div class="sb-live-navbar--actions">
    <ng-content></ng-content>
  </div>
</div>
